import styled from "styled-components";
import DateRangePicker from "react-bootstrap-daterangepicker";

export const StyledDateRangePicker = styled(DateRangePicker)`
    ${props => props.disabled && "pointer-events: none;"}
`;
